<script setup>
import { ref, computed } from 'vue';
import { useStore } from 'vuex';
import { useRoute } from 'vue-router';
import CodeEditor from '@/components/CodeEditor.vue';

const store = useStore();
const route = useRoute();

const draft = computed(() => store.getters['ci/currentCIDraft']).value;
const preScript = ref(draft?.init?.pre || '');
const postScript = ref(draft?.init?.post || '');

function Save(component) {
  store.commit('ci/setPreviewerOperation', {
    operations: [
      {
        component,
        operation: 'PUT',
        details: {
          script: component === 'init.pre' ? preScript.value : postScript.value,
        },
      },
    ],
    ciId: route.params.ciId,
  });
}
</script>

<template>
  <div class="flex flex-col gap-2">
    <h4 class="mt-2 px-2">Init Override Scripts</h4>
    <form class="edit-choice" @submit.prevent="Save('init.pre')">
      <code-editor key="init__pre-script" v-model="preScript" title="Pre Script" />
      <input class="save" value="Save" type="submit" />
    </form>
    <form class="edit-choice" @submit.prevent="Save('init.post')">
      <code-editor key="init__post-script" v-model="postScript" title="Post Script" />
      <input class="save" value="Save" type="submit" />
    </form>
  </div>
</template>

<style lang="postcss" scoped>
.edit-choice {
  @apply col-span-3 flex flex-col gap-4 p-4;
}
input[type='submit'] {
  @apply mb-2 ml-auto cursor-pointer rounded-full border-none bg-brand-500 px-5 py-2 text-sm
         font-medium tracking-wider text-white shadow-sm;
}
input[type='submit']:disabled {
  @apply cursor-not-allowed opacity-25;
}
input[type='submit']:hover {
  @apply bg-brand-600 shadow-lg;
}
</style>
